import { TLinkButtonSize } from './types';

import * as styles from './styles.css';

export const SIZE_TO_CLASS: { [key in TLinkButtonSize]: string } = {
  M: styles['middle'],
  L: styles['large'],
  XL: styles['extra-large'],
};
